import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface PayoutsState {
  filterSearch?: string;
}

export const initialState: PayoutsState = {};

export const payoutsSlice = createSlice({
  name: 'payouts',
  initialState,
  reducers: {
    setFilterSearch(state, action: PayloadAction<string>) {
      state.filterSearch = action.payload;
    },
    clearFilters(state) {
      state.filterSearch = undefined;
    },
  },
  selectors: {
    hasFilters(state) {
      return !!state.filterSearch;
    },
  },
});

export const { setFilterSearch, clearFilters } = payoutsSlice.actions;
export const { hasFilters } = payoutsSlice.selectors;
